import _                                  from 'underscore';
import { DEFAULT_TERM_DICTIONARY }                            from '../lang/termDictionaries';
import { getPaths, mergeDeep, mergeDeepImmutable, putOnPath } from '../util';
import { EMPTY_VALUE_DISPLAY }                                from '../constants/FormatStringEnums';
import { ITermDictionary }                from '../lang/LangTypes';


export class LangService {

    static PATH_SEPARATOR = '.';
    static KEY_SPACE_SEPARATOR = '_';

    static getDictionary = ( dictionary: object | string ) => {

        let _dictionary = LangService.parseDictionary( dictionary );

        return _.isEmpty( _dictionary ) ? DEFAULT_TERM_DICTIONARY : LangService.mergeDictionaries( DEFAULT_TERM_DICTIONARY, _dictionary );
    }

    static parseDictionary = ( dictionary: object | string ) => {

        if( !dictionary ) return {};

        return _.isString( dictionary ) ? JSON.parse( dictionary ) : _.isObject( dictionary ) ? _.clone( dictionary ) : {};
    }

    static getTermFromDictionary = ( path: string | string[], dictionary: object | string = DEFAULT_TERM_DICTIONARY ): string => {

        let _dictionary  = LangService.getDictionary( dictionary ),
            isStringPath = _.isString( path ),
            isArrayPath  = _.isArray( path );

        // No string or array path, return empty display string
        if( !isStringPath && !isArrayPath && !path ){
            return EMPTY_VALUE_DISPLAY;
        }

        try{

            // Ensure a path is available, and detemine a default term
            let pathArray   = isStringPath ? ( path as string ).split( LangService.PATH_SEPARATOR ) : ( path as string[] ).map( p => `${ p }` ),
                defaultTerm = isStringPath ? path : isArrayPath ? ( path as string[] ).join( LangService.PATH_SEPARATOR ) : path;

            // If we have a dictionary, attempt to find the term via the path;
            // Return the default term if not found in dictionary.
            if( _dictionary ){

                return _.get( _dictionary, pathArray, defaultTerm );
            }

            // Otherwise return the default term
            return defaultTerm as string;

        } catch( e ) {

            console.warn( `Bad path or path conversion in LangService: term path = ${ path }` );
        }

        // No valid path value, return empty display string
        return EMPTY_VALUE_DISPLAY;
    };

    static getDictionaryPaths = ( dictionary: object | string = DEFAULT_TERM_DICTIONARY ): string[] => {

        let _dictionary = LangService.parseDictionary( dictionary )

        return getPaths( _dictionary ).map( ( path: string ) => path.substring( 2 ) );
    };

    static getDictionaryKeyValuePairs = ( dictionary: object | string = DEFAULT_TERM_DICTIONARY, pathKey = 'key', valueKey = 'value' ) => {

        let _dictionary = LangService.parseDictionary( dictionary ),
            paths       = LangService.getDictionaryPaths( _dictionary );

        return paths.map( ( path ) => ( {
            [ pathKey ]:  path,
            [ valueKey ]: LangService.getTermFromDictionary( path, _dictionary )
        } ) )
    }

    static constructDictionaryFromKeyValuePairs = ( dictionaryKeyValuePairs: object[], pathKey = 'key', valueKey = 'value' ) => {

        let customDictionary = {};

        if( dictionaryKeyValuePairs.length ){

            dictionaryKeyValuePairs.map( item => {

                putOnPath( customDictionary, item[ pathKey ], item[ valueKey ] );

            } )
        }

        return customDictionary;
    }

    static mergeDictionaries = ( baseDictionary: ITermDictionary, ...otherDictionaries: ITermDictionary[] ) => {


        let _dictionary = LangService.parseDictionary( baseDictionary )

        otherDictionaries.map( dictionary => {

            _dictionary = mergeDeepImmutable( DEFAULT_TERM_DICTIONARY, dictionary );

        } );

        return _dictionary
    }
}
